import classes from '../Classes';
import options from '../../../../constants/carouselOptions.js';

/**
 * Alignment handler giving the "Text Location" value in a "Hero Card" entry.
 * @param {*} _textLocation 
 * @returns 
 */
var heroCardTextLocation = function heroCardTextLocation(_textLocation) {
  var textLocation = _textLocation;
  return {
    getGridAlignment: function getGridAlignment() {
      if (textLocation === options.GRID_ALIGNMENT.TEXT_LEFT) {
        return classes.GRID_ALIGNMENT.START;
      }
      if (textLocation === options.GRID_ALIGNMENT.TEXT_RIGHT) {
        return classes.GRID_ALIGNMENT.END;
      }
      if (textLocation === options.GRID_ALIGNMENT.TEXT_CENTER) {
        return classes.GRID_ALIGNMENT.CENTER;
      }
      return classes.GRID_ALIGNMENT.START; // Default case
    },

    getAlignment: function getAlignment() {
      if (textLocation === options.GRID_ALIGNMENT.TEXT_LEFT) {
        return classes.ALIGNMENT.LEFT;
      }
      if (textLocation === options.GRID_ALIGNMENT.TEXT_RIGHT) {
        return classes.ALIGNMENT.RIGHT;
      }
      if (textLocation === options.GRID_ALIGNMENT.TEXT_CENTER) {
        return classes.ALIGNMENT.CENTER;
      }
      return classes.ALIGNMENT.LEFT; // Default case
    },

    getVerticalAlignment: function getVerticalAlignment() {
      return classes.VERTICAL_ALIGNMENT.CENTER; // Default case
    }
  };
};

export default heroCardTextLocation;